<template>
<div>
    <div class="button__next text-white no-border cancel-plan" @click="showModal()">
        Cancel Plan
    </div>
    <modal name="cancelPlanModal" classes="cancel-plan-modal whatswhat-modal" scrollable="true" :min-height="400" height="auto" width="750px" :shiftY="0.3">
        <div class="cancel-plan-wrapper">
            <div class="close-modal" @click="closeModal()"><i class="icon-cross"></i></div>
            <h3 class="text-center">ARE YOU SURE YOU WANT TO CANCEL?</h3>
            <p class="text-danger text-bold">6 Things you will lose when you cancel.</p>
             <ul>
                 <li>You will lose your <b>Quality Back Link</b> to your Website....this helps your business to reach more customers online & be found ahead of others on search engines.</li>
                 <li>You will lose your <b>Company Page</b> which displays your Products and Service on the largest Irish Business Directory.</li>
                 <li>You will lose your <b>logo</b> and <b>Banner</b> which means you are not visible online to your ideal customers.</li>
                 <li>You will lose all the <b>Benefits and Features</b>, which helps your business to learn more, do more, grow and reach more customers more consistently.</li>
                 <li>Your business <b>will be at the bottom</b> of the barrel within your Category and your sector.</li>
                 <li>Your business <b>will not have the same presence online</b> among your ideal target markets.</li>
             </ul>
            <div class="text-danger text-bold mg-tp-45">This is what happens when you cancel.</div>
            <div class="cancel-testimonial">
                <p>"Recently due to such extremely busy times I let my website go a bit and neglected basic maintenance
                    etc which in turn made my site drop it's rank. I noticed recently as well that my link with
                    WhatsWhat.ie had been overlooked by me which was a big mistake due to the power that WhatsWhat.ie has. </p>

                <p>Regards,</p>
                <p><b>Kevin Horgan.</b>
                <p><b>www.nationaldrivingschool.ie</b></p>
            </div>
            <div class="modal-footer text-center">
                <button id="card-button" class="button__next text-white no-border" @click="cancelPlan()">
                    Cancel
                </button>
            </div>
        </div>
    </modal>
</div>
</template>


<script>


    export default {
        props: ['plan', 'next_billing_date','cancel_route'],
        methods: {
            showModal: function() {
                this.$modal.show('cancelPlanModal')
            },
            closeModal() {
               this.$modal.hide('cancelPlanModal')
            },
            cancelPlan(){
                axios.post(this.cancel_route).then( function(){
                    window.location.reload();
                }.bind(this));
            },
        },

        mounted () {
        }
    }
</script>
